import type { AddSystemRequest, UpdateSystemRequest } from '@bliks-io/contracts';
import { useCreateSystem } from '@/api/mutations/useSystems';
import { SystemFormDialog } from '@/pages/organization/systems/components/SystemFormDialog';

export interface SystemCreateDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  initialName: string;
  /** Fires once the created entity is visible to the picker's list query. */
  onCreated: (id: string) => void;
}

export function SystemCreateDialog({
  open,
  onOpenChange,
  initialName,
  onCreated
}: SystemCreateDialogProps) {
  const createMutation = useCreateSystem();

  // The created system goes back to the dialog for its follow-up logo upload;
  // a rejected create propagates to FormDialog, which keeps the dialog open.
  const handleSubmit = async (data: AddSystemRequest | UpdateSystemRequest) => {
    const result = await createMutation.mutateAsync(data as AddSystemRequest);
    return result.data;
  };

  return (
    <SystemFormDialog
      open={open}
      onOpenChange={onOpenChange}
      defaultValuesOverride={{ name: initialName }}
      onSubmit={handleSubmit}
      onSuccess={(created) => {
        onCreated(created._id);
        onOpenChange(false);
      }}
    />
  );
}
